<div ngbDropdown
    display="dynamic"
    placement="bottom-right"
    #modalSearchCompany="ngbDropdown">
    <button type="button" class="btn nav-link"
        id="company-selector"
        ngbDropdownToggle
        (click)="clickOpenDropdown()">
        <div class="d-flex align-items-center">
            <i class="mdi mdi-domain font-24"></i>
            <span class="ml-1" [hidden]="!companyInfo?.companyNm">{{companyInfo?.companyNm}}</span>
            <span class="ml-1" [hidden]="companyInfo?.companyNm">회사를 선택 해 주세요</span>
        </div>
    </button>
    <div ngbDropdownMenu
        class="dropdown-menu dropdown-menu-right p-2"
        aria-labelledby="company-selector"
        style="min-width: 20vw;">
        <div class="input-group input-group-sm">
            <input type="text"
                class="form-control form-control-sm border-secondary"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button"
                    class="btn btn-sm btn-outline-secondary"
                    (click)="clickSearchCompany($event)">
                    <i class="mdi mdi-magnify"></i>
                    <span class="ml-1">회사검색</span>
                </button>
            </div>
        </div>
        <div class="mt-3">
            <ng-container *ngIf="listCompanyInfo">
                <nav class="nav-tree bg-white overflow-auto" style="max-height:50vh;">
                    <ul class="nav flex-column">
                        <ng-container *ngFor="let item of listCompanyInfo;let idx = index;">
                            <li class="nav-item"
                                company-selector-tree-node
                                [companyInfo]="item">
                            </li>
                        </ng-container>
                    </ul>
                </nav>
            </ng-container>
        </div>
    </div>
</div>

